import { v4 } from "uuid";
import { TApiEndpointKeys } from "../config/config";
import { ensureConfig } from "../services/configuration-service";
import { SmokeballAuthenticator } from "../services/smokeball-authenticator";

export const createAuthorisedApiRequest = async (
  endpointKey: TApiEndpointKeys,
  body: object | null,
  method = "POST",
  params?: Record<string, string>
): Promise<{ url: string; requestInit: RequestInit }> => {
  const regionConfig = ensureConfig();
  const endpoint = regionConfig[endpointKey];
  const authenticator = SmokeballAuthenticator.getSmokeballAuthenticator();
  const token = await authenticator.getTokenFromStorage();

  let bodyJson: string | null = null;
  const reqId = v4();

  if (method !== "GET") {
    if (Array.isArray(body)) {
      bodyJson = JSON.stringify(body);
    } else {
      bodyJson = JSON.stringify({
        RequestId: reqId,
        ...body,
      });
    }
  }

  const url = new URL(endpoint);

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
  }

  return {
    url: url.toString(),
    requestInit: {
      method,
      headers: {
        Authorization: `Bearer ${token?.idtoken}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      body: bodyJson,
    },
  };
};
